<template>
  <div class="chat-box">
    <div class="chat-box-header">
      <div class="chat-box-switch-mode" style="top: 33px" @click="close()">
        <i
          class="material-icons chat-box-menu-button big"
          :title="$t('nomore.back')"
        >
          arrow_back_ios
        </i>
      </div>
      <h2 style="text-align: left; margin-left: 45px; margin-top: 20px">
        Back to Live Video Call
      </h2>
    </div>
    <div class="chat-box-body">
      <div class="chat-content">
        <div
          v-for="(message, i) in videoChatState.messages"
          :key="i"
          class="chat-message-container"
          :class="message.sender_type !== 'self' ? 'left' : 'right'"
        >
          <img
            v-if="message.sender_type !== 'self'"
            class="material-icons chat-avatar"
            :src="admin_avatar"
            alt="Bot Avatar"
          />
          <div class="chat-message">
            {{ message.content }}
          </div>
        </div>
        <div v-if="typing_indicator" class="chat-message-container right">
          <div class="chat-message">
            <typing-indicator v-if="typing_indicator" />
          </div>
        </div>
      </div>
    </div>
    <div class="chat-box-footer">
      <textarea
        id="chat-input"
        v-model="chat_input"
        type="text"
        :placeholder="$t('chat.enter')"
        @keyup.enter="onEnter"
      />
      <button
        v-if="chat_input"
        type="submit"
        class="chat-submit"
        @click="submit"
      >
        <svg focusable="false" aria-hidden="true" viewBox="0 0 16 16">
          <path
            d="M1.388 15.77c-.977.518-1.572.061-1.329-1.019l1.033-4.585c.123-.543.659-1.034 1.216-1.1l6.195-.72c1.648-.19 1.654-.498 0-.687l-6.195-.708c-.55-.063-1.09-.54-1.212-1.085L.056 1.234C-.187.161.408-.289 1.387.231l12.85 6.829c.978.519.98 1.36 0 1.88l-12.85 6.83z"
            fill-rule="evenodd"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import utils from "../../utils";
import TypingIndicator from "../TypingIndicator.vue";
import specs from "@/specs";
import { customLogger } from "@/utils";
export default {
  name: "VideoChatMessages",
  components: {
    TypingIndicator,
  },
  data() {
    return {
      chat_input: "",
      typing_indicator: false,
      admin_avatar: specs._ADMIN_IMG_AVATAR,
    };
  },
  computed: {
    videoChatState() {
      const data = this.$store.state.videoChat;
      return data;
    },
  },
  created() {
    this.videoChatState.messageNotif = false;
  },
  methods: {
    close() {
      customLogger("close chat");
      this.videoChatState.display_messages = false;
    },
    submit() {
      const dateWithouthSecond = new Date();
      const time = dateWithouthSecond.toLocaleTimeString(navigator.language, {
        hour: "2-digit",
        minute: "2-digit",
      });
      const At = new Date();
      const data = {
        content: this.chat_input,
        sender_type: "self",
        mode: "chat",
        video_chat: true,
        context: "video_call",
        time: time,
        sent_at: At.toISOString()
      };
      this.typing_indicator = true;
      this.videoChatState.socketAddr.emit(
        "VIDEO_CHAT_USER_sendMessage",
        data,
        (cb) => {
          if (typeof cb === "string") {
            customLogger(cb);
          } else if (cb.success == false) {
            customLogger(`Error during sending the message : ${cb.error}`);
          } else {
            this.chat_input = "";
            this.typing_indicator = false;
          }
        }
      );
    },
    onEnter() {
      if (!utils.isMobile()) this.submit();
    },
  },
};
</script>
